import HttpService from './HttpService';

class UserService extends HttpService {
  getUsuarios(uuid) {
    return this.get(`/usuarios/${uuid}/users`).then((response) => response.data);
  }

  getUsuarioById(id) {
    return this.get(`/usuarios/${id}`);
  }

  createUsuario(data) {
    return this.post('/usuarios', data);
  }

  updateUsuario(id, data) {
    return this.put(`/usuarios/${id}`, data);
  }

  toInactiveUsuario(uuid) {
    return this.put(`/usuarios/${uuid}/inactive`);
  }

  toActiveUsuario(uuid) {
    return this.put(`/usuarios/${uuid}/active`);
  }

  getUser() {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }
}

export default UserService;
